import axios from 'axios';
import { DEV_SERVER } from '../../../../constants/urls';
import { userSignal } from '../../../../signal/userSignal';
import { getProducts } from '../../../../utilities/getProducts';
import { TallyConfig } from '../helpers/constants';
import * as moment from 'moment';

var hash = require('object-hash');

const getTaxName = (_taxName) => {
    if (_taxName === "CGST" || _taxName.toLowerCase() === "Central Tax".toLowerCase()) {
        return "CGST"
    }
    else if (_taxName === "SGST" || _taxName.toLowerCase() === "State Tax".toLowerCase() || _taxName === "SGST/UTGST") {
        return "SGST"
    }
    else if (_taxName === "IGST" || _taxName.toLowerCase() === "Integrated Tax".toLowerCase()) {
        return "IGST"
    } else {
        return _taxName
    }
}

export async function SyncStockItems(stockItems) {

    try {
        if (!stockItems) {
            console.log("No stock items found")
            return false
        }

        stockItems = stockItems?.ENVELOPE?.BODY?.DATA?.COLLECTION?.STOCKITEM || []

        if(!(stockItems instanceof Array)){
            stockItems = [stockItems]
        }

        if(stockItems.length === 0){
            return true
        }
        
        let products = []

        stockItems.forEach(stockItem => {
            let product = {
                name: stockItem?._attributes?.NAME,
                category: stockItem?.PARENT?._text?.startsWith(``) || stockItem?.PARENT?._text?.startsWith(`\\`) ? "" : stockItem?.PARENT?._text,
                description: stockItem?.DESCRIPTION?._text || "",
                tallyId: stockItem?.MASTERID?._text,
                isTaxEnabled: true
            }

            let _baseUnits = stockItem?.BASEUNITS
            if (!(_baseUnits instanceof Array)) {
                _baseUnits = [_baseUnits]
            }

            product.tallyVatBaseUnit = _baseUnits?.length > 0 ? _baseUnits[0]?._text : ""
            product.packagingTypes = [product?.tallyVatBaseUnit]

            let rate = stockItem?.OPENINGRATE?._text


            if (rate) {
                rate = rate.split(`/${product.tallyVatBaseUnit}`)
                rate = rate[0].trim()
                product.price = parseFloat(rate)
            } else {
                product.price = 0
            }

            if(stockItem["GSTDETAILS.LIST"] !== undefined && stockItem["GSTDETAILS.LIST"] !== null){
                if(!(stockItem["GSTDETAILS.LIST"] instanceof Array)){
                    stockItem["GSTDETAILS.LIST"] = [stockItem["GSTDETAILS.LIST"]]
                }
                let gstList = stockItem["GSTDETAILS.LIST"][stockItem["GSTDETAILS.LIST"].length - 1]
                if(gstList["STATEWISEDETAILS.LIST"] !== undefined && gstList["STATEWISEDETAILS.LIST"] !== null){
                    let rateDetails = gstList["STATEWISEDETAILS.LIST"]["RATEDETAILS.LIST"]

                    if(rateDetails !== undefined && rateDetails !== null){
                        if(!(rateDetails instanceof Array)){
                            rateDetails = [rateDetails]
                        }

                        let temp = {}
                        for(let k=0; k<rateDetails.length; k++){
                            let rate = rateDetails[k]
                            temp[getTaxName(rate["GSTRATEDUTYHEAD"]?._text)] = parseFloat(rate["GSTRATE"]?._text?.trim())
                        }

                        product.taxRates = temp
                    }
                }

                if (gstList["HSNCODE"] !== undefined && gstList["HSNCODE"] !== null) {
                    product.tallyHSNCode = gstList["HSNCODE"]._text
                }
            }

            let _fullPriceList = stockItem["FULLPRICELIST.LIST"]
            if (_fullPriceList!== undefined && _fullPriceList !== null) {
                if (!(_fullPriceList instanceof Array)) {
                    _fullPriceList = [_fullPriceList]
                }

                let temp = {}
                for (let k = 0; k < _fullPriceList.length; k++) {
                    if (_fullPriceList[k] === undefined || _fullPriceList[k] === null || _fullPriceList[k]?.PRICELEVEL === undefined || _fullPriceList[k]?.PRICELEVEL === null) {
                        continue
                    }

                    let applicableFrom = _fullPriceList[k]?.DATE?._text
                    applicableFrom = moment(applicableFrom, "YYYYMMDD").format("YYYYMMDD")
                    let currentDate = moment().format("YYYYMMDD")
                    
                    if(currentDate < applicableFrom){
                        continue
                    }

                    let priceList = _fullPriceList[k]?.PRICELEVEL?._text
                    temp[priceList] = []

                    if (_fullPriceList[k]["PRICELEVELLIST.LIST"] === undefined || _fullPriceList[k]["PRICELEVELLIST.LIST"] === null) {
                        continue
                    }

                    let priceListItems = _fullPriceList[k]["PRICELEVELLIST.LIST"]
                    if (!(priceListItems instanceof Array)) {
                        priceListItems = [priceListItems]
                    }

                    for (let j = 0; j < priceListItems.length; j++) {
                        let priceListItem = priceListItems[j]
                        let _discount = priceListItem?.DISCOUNT?._text || 0
                        _discount = _discount ? parseFloat(_discount) : 0
                        let _rate = priceListItem?.RATE?._text || 0
                        _rate = _rate ? parseFloat(_rate) : 0
                        let _startingFrom = priceListItem?.STARTINGFROM?._text || 0
                        _startingFrom = _startingFrom ? parseFloat(_startingFrom) : 0
                        let _endingAt = priceListItem?.ENDINGAT?._text || 1000000000000
                        _endingAt = _endingAt ? parseFloat(_endingAt) : 0

                        temp[priceList].push({
                            discount: _discount,
                            rate: _rate,
                            startingFrom: _startingFrom,
                            endingAt: _endingAt
                        })
                    }
                }

                product.tallyPriceList = temp
            }

            products.push(product)
        })

        let resp = await window.electron.grpcConnect({
            userId: userSignal?.value?.user.id,
            organisationId: userSignal?.value?.user?.organisation,
            reqType: "syncProducts",
            products: JSON.stringify(products),
        })

        // wait for 2s
        await new Promise((resolve, reject) => {
            setTimeout(async () => {
                resolve()
            }, 5000)
        })

    } catch (err) {
        console.log(err)
        return false
    }

}